<template>
  <!-- FOOTER 
  =============================================-->
  <section>
    <div class="clear"></div>
    <div class="row ft-reponsive">
      <div class="col-lg-3 col-md-3 col-5" style="text-align: center; ">
        <img
          :src="getApiPath('736fde42-082e-49d0-a1a8-460165a876ea.jpg')"
          alt="Wintershop Thailand"
          style="margin-right: 20px;"
        />
      </div>

      <div class="col-lg-3 col-md-3 col-7">
        <div class="fancy-title title-border">
          <h4>BRAND NAME FOR RENT</h4>
        </div>
        <p class="responsive-ft-font">
          ทริปด่วน ออกงานด่วน นึกถึง Brandnameforrent.official
          <br />Line : @brandnameforrent <br />เปิดบริการ 09:00-18:00 <br />
          จองออนไลน์ตลอด 24 ชม.
        </p>
      </div>

      <div class="col-lg-6 col-md-6 col-12">
        <div class="fancy-title title-border">
          <h4>Connect with Us</h4>
        </div>
        <div class="row" style="padding-top:20px;">
          <div class="social_banner col-lg-1 col-md-1 col-1"></div>
          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('fb_logo.png')"
              style="cursor:pointer; border-radius:10px;"
              @click="
                redirectToExternal(
                  'https://www.facebook.com/Brandnameforrent.official'
                )
              "
            />
          </div>

          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('ig_logo.png')"
              style="cursor:pointer;; border-radius:10px;"
              @click="
                redirectToExternal(
                  'https://www.instagram.com/brandnameforrent.official'
                )
              "
            />
          </div>
          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('line_logo.png')"
              style="cursor:pointer;  border-radius:10px;"
              @click="redirectToExternal('https://lin.ee/Hei6OYB')"
            />
          </div>

          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('line_openchat.png')"
              style="cursor:pointer;  border-radius:10px;"
              @click="
                redirectToExternal(
                  'https://line.me/ti/g2/WbXChYutgaW4bcDCQK3SUISr2NbBfih4UKgOtA?utm_source=invitation&utm_medium=link_copy&utm_campaign=default'
                )
              "
            />
          </div>

          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('tiktok.png')"
              style="cursor:pointer;  border-radius:10px;"
              @click="
                redirectToExternal(
                  'https://www.tiktok.com/@brandnameforrent.byjaae?_t=8UWEcqFTbtK&_r=1'
                )
              "
            />
          </div>
          <div class="social_banner col-lg-1 col-md-1 col-1"></div>
        </div>
      </div>
    </div>
  </section>
  <!-- row -->
</template>
<script>
import store from "@/store.js";
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {};
  },
  methods: {
    getFullPath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return store.state.imageUrl + "defaultimage.png";
      } else {
        return store.state.imageUrl + mainImage;
      }
    },
  },
  components: {},
};
</script>

<style>
.ft-reponsive {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 90px;
  padding-bottom: 40px;
}
@media only screen and (max-width: 800px) {
  .ft-reponsive {
    margin-left: auto;
    margin-right: auto;
    margin-top: 0 !important;
    padding-bottom: 40px;
    margin-bottom: 220px !important;
  }
  .responsive-ft-font {
    font-size: 0.6rem !important;
  }
  .fancy-title {
    position: relative;
    margin-bottom: 10px !important;
    margin-top: 10px !important;
    font-size: 0.8rem !important;
  }
}
</style>